import { render, staticRenderFns } from "./tagList.vue?vue&type=template&id=d77ce7da&scoped=true"
import script from "./tagList.vue?vue&type=script&lang=js"
export * from "./tagList.vue?vue&type=script&lang=js"
import style0 from "./tagList.vue?vue&type=style&index=0&id=d77ce7da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d77ce7da",
  null
  
)

export default component.exports